module.exports = __webpack_public_path__ + "img/undraw_Online_learning_re_qw08.7efaabe7.svg";